import { request2, request1 } from '../network/request'
// 获取业绩排行接口 /TStudentFocuseApi/BusinessCommission/GetAchievementRankingList
export function GetAchievementRankingList(data) {
    return request2({
        url: '/api2/TZsbAdminFocuseApi/BusinessCommission/GetAchievementRankingList',
        method: 'get',
        params: {
            MonthData: data.monthDate,
            SuperiorId: data.superiorId,
            TeamId: data.teamId,
            AgreementState: data.agreementState,
            OrderByField:data.orderByField
        }
    })
}

// 获取所属上级集合 
export function GetSuperiorList() {
    return request1({
        // url: '/api2/TZsbAdminApi/Team/GetSuperiorList',
        url: '/api2/TZsbWebAdminApi/TeamWeb/GetSuperiorList',
        method: 'get',
    })
}

// 获取所属上级下的小组 
export function GetTeamBySuperior(id) {
    return request1({
        // url: '/api2/TZsbAdminApi/Team/GetTeamBySuperior?id=' + id,
        url: '/api2/TZsbWebAdminApi/TeamWeb/GetTeamBySuperior?id=' + id,
        method: 'get',
    })
}

// 语音播报 
export function SpeakMessage(message) {
    return request1({
        url: '/api2/TZsbWebAdminApi/Home/SpeakMessage?message=' + message,
        method: 'get',
    })
}

// 基于小组id集合，获取语音播报数据
export function GetBroadcastContent(data) {
    return request1({
        // url: '/api2/TZsbAdminApi/Team/GetBroadcastContent',
        url: '/api2/TZsbWebAdminApi/TeamWeb/GetBroadcastContent',
        method: 'post',
        data: data
    })
}